import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
var iconContainerStyles = xcss({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'opacity 0.2s ease',
  position: 'absolute',
  insetBlockStart: 'space.025'
});
var iconContainerRegularStyles = xcss({
  width: '16px',
  height: '16px'
});
var iconContainerLargeStyles = xcss({
  width: '20px',
  height: '20px'
});
var hiddenStyles = xcss({
  opacity: 0
});
var leftStyles = xcss({
  insetInlineStart: '3px'
});
var rightStyles = xcss({
  insetInlineEnd: '3px'
});

/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */
var IconContainer = function IconContainer(_ref) {
  var children = _ref.children,
    size = _ref.size,
    isHidden = _ref.isHidden,
    position = _ref.position;
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: [iconContainerStyles, isHidden && fg('platform.design-system-team.enable-new-icons') && hiddenStyles, size === 'regular' && iconContainerRegularStyles, size === 'large' && iconContainerLargeStyles, position === 'left' && leftStyles, position === 'right' && rightStyles]
  }, children);
};
export default IconContainer;